import React, { FC, PropsWithChildren, useEffect, useMemo } from 'react'

import { useDispatch } from 'react-redux'

import { removeNotificationAction } from 'actions/notificationAction'
import { shouldRedirectWithPush } from 'components/uninotice/UniNotice.functions'
import { UniNoticeInline } from 'components/uninotice/UniNoticeInline'
import { UniNoticeInlineRedirect } from 'components/uninotice/UniNoticeInlineRedirect'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { uniNoticeReducer } from 'reducers/uniNoticeReducer'

/**
 * Показывает первый активный юни нотис, если он есть.
 * Иначе детей (нужно для старых нотификаций).
 * @constructor
 */
export const ActiveUniNoticeInline: FC<PropsWithChildren> = ({ children }) => {
  useReducersInsert({ uniNoticeReducer: uniNoticeReducer })
  const dispatch = useDispatch()
  const { activeInline } = useShallowEqualSelector(
    ({ uniNoticeReducer: { activeInline } }) => ({
      activeInline,
    })
  )
  // первый активный нотис, у которого true
  const [firstId] = useMemo(
    () => Object.keys(activeInline).filter((key) => activeInline[key]),
    [activeInline]
  )
  const shouldRedirect = useMemo(
    () => shouldRedirectWithPush(firstId),
    [firstId]
  )

  useEffect(() => {
    return () => {
      // очистить нотайс, чтобы показанный не перекрывал новый
      if (activeInline[firstId] && !shouldRedirect) {
        dispatch(removeNotificationAction(firstId))
      }
    }
  }, [firstId, activeInline, shouldRedirect, dispatch])

  if (activeInline[firstId]) {
    if (shouldRedirect) {
      return <UniNoticeInlineRedirect watchedNotice={firstId} replace={false} />
    }
    return <UniNoticeInline watchedNotice={firstId} />
  }
  return <>{children}</>
}
